// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"235": "styled-components","271": "socketio","300": "common","389": "apollo","841": "utilities","844": "antd",}[chunkId] || chunkId) + ".chunk.js"
}